<template>
  <div class="private-chat">
    <div class="private-header">
      <div class="a" @click="back">
        <img src="./img/back-arrow.png" alt="" />
        <div>{{ $t("chat.back") }}</div>
      </div>
      <div class="c">{{ $t("pcLive.privateChat") }}</div>
      <div class="d"></div>
    </div>
    <div class="private-content" ref="privateChat" @scroll="onscroll">
      <img
        v-show="isLoadingMore"
        src="@/assets/img/loading-1.gif"
        alt=""
        style="display: block; margin: 0 auto"
      />
      <div
        class="message-list"
        v-for="(item, index) in privateMessageList"
        :key="index"
      >
        <div class="chat-time" v-show="item.chatType === 3">
          {{ item.content }}
        </div>
        <div
          class="chat-anchor"
          v-show="item.chatType === 2 && item.sender_uid === roomId"
        >
          <img
            class="avatar"
            :src="
              item.avatar
                ? item.avatar
                : require('@/assets/img/default/default_logo1.png')
            "
            alt=""
          />
          <div class="msg">
            <img class="angle" src="./img/angle-left.png" alt="" />
            <div class="nickname">{{ item.nick_name }}</div>
            <div class="text">{{ item.content }}</div>
          </div>
        </div>
        <div class="chat-user" v-show="item.chatType === 1">
          <div class="msg">
            <div
              class="red-dot"
              v-show="errorMessageIds.indexOf(item.time) > -1"
              @click="showErrorMsg"
            >
              !
            </div>
            <img class="angle" src="./img/angle-right.png" alt="" />
            <div class="text">{{ item.content }}</div>
          </div>
          <img
            class="avatar"
            :src="
              userInfo.avatar
                ? userInfo.avatar
                : require('@/assets/img/default/default_logo1.png')
            "
            alt=""
          />
        </div>
      </div>
    </div>
    <div class="to_bottom_btn" @click="toBottom" v-if="showMoreMsg">
      {{ $t("chat.thereIsNew") }}
    </div>
    <div class="message_bottom">
      <div class="icon_btn">
        <emoji-picker @emoji="insert">
          <div
            slot="emoji-invoker"
            slot-scope="{ events: { click: clickEvent } }"
            @click.stop="clickEvent"
          >
            <img class="icon-img" src="./img/emoji.png" title="表情" />
          </div>
          <div
            class="emoji"
            slot="emoji-picker"
            slot-scope="{ emojis, insert }"
          >
            <div class="emoji-cats">
              <div
                class="emoji-cat"
                :class="emojiCategory == index ? 'emoji-active' : ''"
                @click="changeEmojiCategory(index)"
                v-for="(item, index) in emojiCates"
                :key="index"
              >
                {{ item }}
              </div>
            </div>
            <div
              v-for="(emojiGroup, category, index) in emojis"
              :key="category"
            >
              <div class="emoji-item" v-if="emojiCategory == index">
                <span
                  v-for="(emoji, emojiName) in emojiGroup"
                  :key="emojiName"
                  @click="insert(emoji)"
                  :title="emojiName"
                  >{{ emoji }}</span
                >
              </div>
            </div>
          </div>
        </emoji-picker>
      </div>
      <div class="sent_content">
        <div class="input_content">
          <input
            type="text"
            class="login_input"
            required="required"
            v-model="messageContent"
            @keyup.enter="sendMsg()"
          />
        </div>
        <div class="input_send" @click="sendMsg">{{ $t("chat.sendText") }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import { post } from "../../util/http";
import { EmojiPicker } from "vue-emoji-picker";
import TIM from "tim-js-sdk";
import { tim } from "@/util/tim";
import { format } from "@/util/time";
export default {
  components: { EmojiPicker },
  computed: {
    ...mapState([
      "userInfo",
      "appConfig",
      "privateMessageList",
      "isLoadingMore",
      "noMoreMsg",
    ]),
    roomId() {
      return this.liveDetail.anchorid || 0;
    },
  },
  props: {
    liveDetail: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  watch: {
    privateMessageList() {
      if (!this.isBottom) {
        this.showMoreMsg = true;
      }
      if (this.isBottom) {
        this.toBottom();
      }
    },
  },

  data() {
    return {
      // privateMessageList: [],
      emojiCates: [
        this.$t("emoji.recently"),
        this.$t("emoji.smile"),
        this.$t("emoji.anima"),
        this.$t("emojiPicker.project"),
      ],
      isShowPlug: false,
      messageContent: "",
      emojiCategory: 0,
      errorMessageIds: [],
      errorMsg: "",
      isBottom: true,
      showMoreMsg: false,
      page: 1,
    };
  },
  created() {},
  destroyed() {
    // if (this.privateMessageList.length > 0) {
    //   this.readMsg(parseInt(this.privateMessageList[this.privateMessageList.length - 1].send_time / 1000));
    // }
    this.changePrivateMessageList([]);
    this.changeIsEnterPrivateChat(false);
  },
  mounted() {
    this.getPrivateHistory();
    this.changeNoMoreMsg(false);
    this.changeIsEnterPrivateChat(true);
  },
  methods: {
    ...mapMutations([
      "changeUserInfo",
      "toggleLogin",
      "pushToast",
      "changePrivateMessageList",
      "changeIsLoadingMore",
      "changeNoMoreMsg",
      "changeIsEnterPrivateChat",
    ]),
    ...mapActions(["getChatList", "getPrivateHistory"]),
    back() {
      this.$emit("changePrivateChat", false);
    },
    changeEmojiCategory(category) {
      this.emojiCategory = category;
    },
    insert(emoji) {
      this.messageContent += emoji;
    },
    // readMsg(latestMsgStamp) {
    //   post({
    //     url: "/api/privateChat/read",
    //     data: { device_id: localStorage.getItem("device_no"), anchor_id: this.roomId, latest_msg_stamp: latestMsgStamp },
    //   })
    //     .then(({ data }) => {
    //       this.getChatList();
    //     })
    //     .catch((err) => {
    //       console.log("err: ", err);
    //     });
    // },

    sendMsg() {
      if (!this.messageContent.trim()) {
        this.messageContent = "";
        this.pushToast(this.$t("chat.empty"));
        return;
      }
      //未回复仅接收3条信息;
      // let msgList = this.privateMessageList;
      // if (msgList.length >= 3 && msgList[msgList.length - 1].chatType === 1 && msgList[msgList.length - 2].chatType === 1 && msgList[msgList.length - 3].chatType === 1) {
      //   this.$message.error("主播未回复仅接收3条信息");
      //   return;
      // }

      // 发送消息
      const msg = {
        type: "private_message",
        groupId: this.roomId,
        session_id: 0,
        content: window.encrypt(this.messageContent.trim()), //接口提供wasm加密
      };

      console.log("this.privateMessageList", this.privateMessageList);
      let nowTime = Date.parse(new Date());
      let lastMsgTime =
        this.privateMessageList[this.privateMessageList.length - 1]?.time || 0;
      console.log(nowTime, lastMsgTime, "time");
      //相隔60秒添加时间线
      if (nowTime - lastMsgTime > 60000) {
        this.privateMessageList.push({
          chatType: 3,
          time: nowTime,
          content: format(nowTime, "MM-dd hh:mm"),
        });
      }
      this.privateMessageList.push({
        chatType: 1,
        time: nowTime,
        content: this.messageContent.trim(),
      });
      this.timSend(msg, nowTime);
      this.messageContent = "";

      console.log(msg, "msg");
    },
    timSend(msg, nowTime) {
      let msgJson = JSON.stringify(msg);
      let message = tim.createCustomMessage({
        to: "admin",
        conversationType: TIM.TYPES.CONV_C2C,
        payload: {
          data: msgJson,
        },
      });
      // 2. 发送消息
      let promise = tim.sendMessage(message);
      promise
        .then((imResponse) => {
          // 发送成功
          console.log("发送成功", imResponse);
        })
        .catch((imError) => {
          // 发送失败
          this.errorMessageIds.push(nowTime);
          this.errorMsg = imError.message;
          if (imError.code === 120001) {
            this.errorMsg = this.$t("chat.sendAfterReply");
            this.$message.error(this.$t("chat.sendAfterReply"));
            return;
          }
          this.$message.error(imError.message);
        });
    },
    onscroll() {
      // 是否滚动到了底部
      let chatBox = this.$refs.privateChat;
      let clientHeight = chatBox?.clientHeight;
      let scrollTop = chatBox?.scrollTop;
      let scrollHeight = chatBox?.scrollHeight;
      if (scrollTop + clientHeight >= scrollHeight - 10) {
        this.showMoreMsg = false;
        this.isBottom = true;
      } else {
        this.isBottom = false;
      }
      if (scrollTop === 0) {
        console.log("toTop");
        this.page++;
        if (!this.noMoreMsg) {
          this.getRecordDetail(this.page);
        }
      }
    },
    toBottom() {
      this.$nextTick(() => {
        // this.$refs["privateChat"].scrollIntoView();
        if (this.$refs["privateChat"]) {
          this.$refs["privateChat"].scrollTop =
            this.$refs["privateChat"].scrollHeight;
        }
      });
    },
    showErrorMsg() {
      this.$message.error(this.errorMsg);
    },
  },
};
</script>

<style scoped lang="scss">
.private-chat {
  // flex: 1;
  width: 3.4rem;
  display: flex;
  flex-direction: column;
  overflow: scroll;
  position: relative;
  /*火狐下隐藏滚动条*/
  scrollbar-width: none;
  margin-top: 0.12rem;
  margin-right: 0.4rem;
  .private-header {
    height: 0.42rem;
    display: flex;
    align-items: center;
    background: linear-gradient(
        0deg,
        rgba(2, 168, 162, 0.15),
        rgba(2, 168, 162, 0.15)
      ),
      #ffffff;
    .a {
      display: flex;
      width: 0.8rem;
      color: #666666;
      font-size: 0.12rem;
      cursor: pointer;
      img {
        width: 0.16rem;
        height: 0.16rem;
        margin-left: 0.12rem;
        margin-right: 0.05rem;
      }
    }
    .c {
      flex: 1;
      text-align: center;
      color: #000000;
    }
    .d {
      width: 0.8rem;
    }
  }
  .private-content {
    flex: 1;
    border-bottom: 1px solid #eee;
    overflow-y: auto;
    position: relative;
    // padding: 0 0.12rem;
    background: #fff;
    /*火狐下隐藏滚动条*/
    scrollbar-width: none;
    padding: 0.08rem 0.12rem;
    color: #333333;
    .chat-time {
      text-align: center;
      margin-bottom: 0.12rem;
      color: #999;
      font-size: 0.12rem;
    }
    .chat-anchor {
      display: flex;
      align-items: flex-end;
      line-height: 0.2rem;
      margin-bottom: 0.16rem;
      .avatar {
        width: 0.28rem;
        height: 0.28rem;
        border-radius: 0.28rem;
        margin-right: 0.08rem;
      }
      .msg {
        max-width: 2.34rem;
        padding: 0.05rem 0.12rem;
        background: #f4f4f4;
        border-radius: 0.1rem 0.1rem 0.1rem 0px;
        position: relative;
        .nickname {
          color: #8393bc;
        }
        .angle {
          width: 0.07rem;
          position: absolute;
          left: -0.07rem;
          bottom: 0;
        }
        .text {
          word-break: break-all;
        }
      }
    }
    .chat-user {
      display: flex;
      justify-content: flex-end;
      align-items: flex-end;
      line-height: 0.2rem;
      margin-bottom: 0.16rem;
      .msg {
        max-width: 2.34rem;
        padding: 0.05rem 0.12rem;
        background: rgba(2, 168, 162, 0.2);
        border-radius: 0.1rem 0.1rem 0px 0.1rem;
        position: relative;
        .red-dot {
          position: absolute;
          top: 0.08rem;
          left: -0.2rem;
          background: #db6372;
          width: 0.16rem;
          height: 0.16rem;
          border-radius: 0.16rem;
          line-height: 0.16rem;
          text-align: center;
          color: #ffffff;
          margin-right: 0.04rem;
          cursor: pointer;
        }
        .angle {
          width: 0.07rem;
          position: absolute;
          right: -0.07rem;
          bottom: 0;
        }
        .text {
          word-break: break-all;
        }
      }
      .avatar {
        width: 0.28rem;
        height: 0.28rem;
        border-radius: 0.28rem;
        margin-left: 0.08rem;
      }
    }
  }
  .to_bottom_btn {
    width: 3.4rem;
    height: 0.3rem;
    background: rgba(2, 168, 162, 0.7);
    text-align: center;
    line-height: 0.3rem;
    color: #fff;
    font-size: 0.12rem;
    position: relative;
    cursor: pointer;
    &::before {
      content: "";
      width: 0;
      height: 0;
      position: absolute;
      bottom: 0;
      left: 32%;
      transform: translateY(-50%);
      border: 0.05rem solid transparent;
      border-top: 0.05rem solid #fff;
    }
  }
  .message_bottom {
    position: relative;
    // height: 1.08rem;
    height: 1rem;
    padding: 0 0.16rem;
    background: #ffffff;
    .icon_btn {
      display: flex;
      align-items: center;
      height: 0.4rem;
      .icon-img {
        width: 0.3rem;
        height: 0.3rem;
        margin-right: 0.1rem;
        cursor: pointer;
      }
    }
    .emoji {
      width: 3.39rem;
      position: absolute;
      top: -1.6rem;
      left: 0;
      background-color: #fff;
      border-top: 0.01rem solid #eee;
    }
    .emoji-cats {
      display: flex;
      .emoji-cat {
        width: 0.85rem;
        height: 0.3rem;
        background-color: #eee;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }
      .emoji-active {
        background-color: #fff;
      }
    }
    .emoji-item {
      height: 1.3rem;
      padding: 0.1rem;
      overflow: scroll;
      span {
        margin: 0.03rem;
        margin-bottom: 0.05rem;
        display: inline-block;
        cursor: pointer;
      }
    }

    .sent_content {
      width: 100%;
      display: flex;

      .input_content {
        flex: 1;
        background: #ffffff;
        border: 1px solid #f0f0f0;
        border-radius: 4px 0 0 4px;
        height: 0.48rem;
        font-size: 0.12rem;
        display: flex;
        justify-content: space-between;

        .login_input {
          width: 100%;
          padding: 0.12rem 0.16rem;
          border: none;
          outline: none;
          height: 100%;
        }
      }
      .input_send {
        background: #02a8a2;
        border-radius: 0px 4px 4px 0px;
        color: #fff;
        width: 0.6rem;
        height: 0.48rem;
        font-size: 0.14rem;
        text-align: center;
        line-height: 0.48rem;
        cursor: pointer;
      }
    }
  }
}
</style>
